<template>
  <v-dialog persistent v-model="dialog" max-width="700" scrollable>
    <template v-slot:activator="{ on }">
      <v-btn text color="primary" v-on="on">
        <v-icon class="mr-2">mdi-file-plus</v-icon>ADICIONAR DOCUMENTOS
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Adicionar documentos
        <v-spacer />
        <v-btn icon @click="fechar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text :class="{ 'px-0': this.documentos.length > 0 }">
        <div
          class="d-flex align-center justify-center dragzone"
          ref="dropzone"
          @click="selecionar()"
          v-on:drop="drop"
          v-on:dragover="allowDrop"
          v-if="documentos.length === 0"
        >
          <h2 class="headline text-center">
            Arraste e solte os arquivos aqui...
            <br />
            <span class="caption">ou clique para iniciar a seleção</span>
          </h2>
          <input
            type="file"
            class="d-none"
            ref="inputFile"
            multiple
            @change="carregarArquivos"
          />
        </div>
        <v-list three-line v-if="documentos.length > 0">
          <template v-for="(documento, i) in documentos">
            <adicionar-documento-form
              :key="`documento-${i}`"
              :url-base="urlBase"
              :index="i"
              v-model="documentos[i]"
              :adicionados="adicionados"
              :adicionando="documentos"
              @remover="remover(documento)"
            />
            <v-divider v-if="i < documentos.length" :key="`divider-${i}`" />
          </template>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="fechar()">CANCELAR</v-btn>
        <v-btn
          class="primary"
          depressed
          :disabled="disabled"
          @click="adicionar()"
          >ADICIONAR</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";
import AdicionarDocumentoForm from "./AdicionarDocumentoForm";
export default {
  components: { AdicionarDocumentoForm },
  props: ["urlBase", "adicionados"],
  data() {
    return {
      dialog: false,
      documentos: [],
    };
  },
  computed: {
    disabled() {
      if (this.documentos.length === 0) {
        return true;
      }
      for (let doc of this.documentos) {
        if (!doc.valido) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    selecionar() {
      this.$refs.inputFile.value = null;
      this.$refs.inputFile.click();
    },
    allowDrop(e) {
      e.preventDefault();
    },
    drop(e) {
      e.preventDefault();

      this.carregarArquivos(e);
    },
    carregarArquivos(e) {
      let files;
      if (e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if (e.target) {
        files = e.target.files;
      }

      for (let file of files) {
        const doc = _.clone(this.$store.state.documento.modelo);
        doc.arquivo = file;
        doc.nome_original = file.name;
        this.documentos.push(doc);
      }
    },
    remover(doc) {
      const docs = this.documentos;
      this.documentos = [];
      const idx = docs.indexOf(doc);
      if (idx > -1) {
        docs.splice(idx, 1);
      }
      this.$nextTick(() => {
        this.documentos = docs;
      });
    },
    adicionar() {
      this.$emit("adicionar", this.documentos);
      this.dialog = false;
    },
    fechar() {
      this.dialog = false;
      this.documentos = [];
    },
  },
};
</script>

<style scoped>
.dragzone {
  width: 100%;
  height: 150px;
  border: 3px dashed #bbb;
  border-radius: 5px;
}
</style>
